import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Observable, Subject } from 'rxjs';
import { FuseLoadingService } from '@fuse/services/loading';

@Component({
    selector        : 'fuse-loading-bar',
    templateUrl     : './loading-bar.component.html',
    styleUrls       : ['./loading-bar.component.scss'],
    encapsulation   : ViewEncapsulation.None,
    exportAs        : 'fuseLoadingBar',
    changeDetection : ChangeDetectionStrategy.OnPush
})
export class FuseLoadingBarComponent implements OnChanges, OnDestroy
{
    @Input() autoMode: boolean = true;

    // Expose observables directly — async pipe subscribes and drives CD
    mode$: Observable<'determinate' | 'indeterminate'>;
    progress$: Observable<number>;
    show$: Observable<boolean>;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(private _fuseLoadingService: FuseLoadingService)
    {
        this.mode$     = this._fuseLoadingService.mode$;
        this.progress$ = this._fuseLoadingService.progress$;
        this.show$     = this._fuseLoadingService.show$;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void
    {
        // Auto mode
        if ( 'autoMode' in changes )
        {
            // Set the auto mode in the service
            this._fuseLoadingService.setAutoMode(coerceBooleanProperty(changes.autoMode.currentValue));
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
